import { Auth } from "@/utils/index.js";

let autoClaimRouterConfig = [
  {
    path: "/ui/insu/vuex/auto-claim/authAgreeInfo",
    name: "authAgreeInfo",
    component: () =>
      import(
        /* webpackChunkName: "authAgreeInfo" */ "@/layout/auto-claim/AuthAgreeInfo"
      ),
    meta: {
      title: "서비스 약관",
      layout: "/EmptyLayout",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/selfAuthSelect",
    name: "selfAuthSelect",
    component: () =>
      import(
        /* webpackChunkName: "selfAuthSelect" */ "@/layout/auto-claim/SelfAuthSelect"
      ),
    meta: {
      title: "본인 인증",
    },
  },
  {
    // 휴대본 본인인증 폼
    path: "/ui/insu/vuex/auto-claim/identity",
    name: "identity",
    component: () =>
      import(
        /* webpackChunkName: "identity" */ "@/layout/auto-claim/MobileIdentityForm"
      ),
    meta: {
      title: "휴대폰 본인인증",
    },
  },
  {
    // 인증번호 입력
    path: "/ui/insu/vuex/auto-claim/certInput",
    name: "certInput",
    component: () =>
      import(
        /* webpackChunkName: "certInput" */ "@/layout/auto-claim/CertificationInput"
      ),
    meta: {
      title: "휴대폰 본인인증",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/jumin",
    name: "jumin",
    component: () =>
      import(
        /* webpackChunkName: "jumin" */ "@/layout/auto-claim/security/JuminInput"
      ),
    meta: {
      title: "주민등록번호",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/possibleHospital",
    name: "possibleHospital",
    component: () =>
      import(
        /* webpackChunkName: "possibleHospital" */ "@/layout/auto-claim/security/PossibleHospitals"
      ),
    meta: {
      title: "자동청구 병원 선택",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/insuChoose",
    name: "insuChoose",
    component: () =>
      import(
        /* webpackChunkName: "InsuChoose" */ "@/layout/auto-claim/security/InsuChoose"
      ),
    meta: {
      title: "보험사 선택",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/claimAgreeInfo",
    name: "claimAgreeInfo",
    component: () =>
      import(
        /* webpackChunkName: "claimAgreeInfo" */ "@/layout/auto-claim/security/ClaimAgreeInfo"
      ),
    meta: {
      title: "내 보험사 약관 동의",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/paymentAccount",
    name: "paymentAccount",
    component: () =>
      import(
        /* webpackChunkName: "paymentAccount" */ "@/layout/auto-claim/security/PaymentAccount"
      ),
    meta: {
      title: "지급 계좌",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/document",
    name: "document",
    component: () =>
      import(
        /* webpackChunkName: "claimDocument" */ "@/layout/auto-claim/security/Document"
      ),
    meta: {
      title: "증빙서류",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/paymentCenter",
    name: "paymentCenter",
    component: () =>
      import(
        /* webpackChunkName: "paymentCenter" */ "@/layout/auto-claim/security/PaymentCenter"
      ),
    meta: {
      title: "지급센터",
    },
  },
  {
    //
    path: "/ui/insu/vuex/auto-claim/security/idPhotoInfo",
    name: "securityIdPhotoInfo",
    component: () =>
      import(
        /* webpackChunkName: "securityIdPhotoInfo" */ "@/layout/auto-claim/security/IdPhotoInfo"
      ),
    meta: {
      title: "신분증 촬영",
      path: "securityIdPhotoInfo",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/photo",
    name: "idPhoto",
    component: () =>
      import(
        /* webpackChunkName: "idPhoto" */ "@/layout/auto-claim/security/IDPhoto"
      ),
    meta: {
      title: "신분증 촬영",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/expenses",
    name: "expenses",
    component: () =>
      import(
        /* webpackChunkName: "expenses" */ "@/layout/auto-claim/security/MedicalExpenses"
      ),
    meta: {
      title: "청구 진료비 설정",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/retro",
    name: "retro",
    component: () =>
      import(
        /* webpackChunkName: "retro" */ "@/layout/auto-claim/security/RetroClaim"
      ),
    meta: {
      title: "자동청구 소급 기간",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/adress",
    name: "adress",
    component: () =>
      import(
        /* webpackChunkName: "adress" */ "@/layout/auto-claim/security/AddressInput"
      ),
    meta: {
      title: "주소",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/job",
    name: "job",
    component: () =>
      import(
        /* webpackChunkName: "job" */ "@/layout/auto-claim/security/JobInput"
      ),
    meta: {
      title: "직업",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/email",
    name: "email",
    component: () =>
      import(
        /* webpackChunkName: "email" */ "@/layout/auto-claim/security/EmailInput"
      ),
    meta: {
      title: "이메일",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/signature",
    name: "sigNatureInput",
    component: () =>
      import(
        /* webpackChunkName: "SignatureInput" */ "@/layout/auto-claim/security/SignatureInput"
      ),
    meta: {
      title: "서명",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/security/applyHistory",
    name: "applyHistory",
    component: () =>
      import(
        /* webpackChunkName: "applyHistory" */ "@/layout/auto-claim/security/ApplyHistory"
      ),
    meta: {
      title: "자동청구 가입 정보 요약",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/excute",
    name: "excute",
    component: () =>
      import(/* webpackChunkName: "excute" */ "@/layout/auto-claim/ExcuteApp"),
    meta: {
      title: "",
      useBackBtn: false,
    },
  },
  {
    //
    path: "/ui/insu/vuex/auto-claim/security/docComissionView",
    name: "comission",
    component: () =>
      import(
        /* webpackChunkName: "comission" */ "@/layout/auto-claim/security/DocComissionView"
      ),
    meta: {
      title: "위임장",
    },
  },
  {
    //
    path: "/ui/insu/vuex/auto-claim/security/docAgreeView",
    name: "docAgree",
    component: () =>
      import(
        /* webpackChunkName: "docAgree" */ "@/layout/auto-claim/security/DocAgreeView"
      ),
    meta: {
      title: "동의서",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/introduce/:hospitalCd",
    name: "introduce",
    component: () =>
      import(
        /* webpackChunkName: "introduce" */ "@/layout/auto-claim/IntroduceController"
      ),
    meta: {
      layout: "/EmptyLayout",
    },
    beforeEnter: (to, from, next) => {
      if (isNaN(to.params.hospitalCd)) {
        next(`/ui/insu/vuex/auto-claim/${to.params.hospitalCd}`);
      } else {
        next();
      }
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/",
    name: "innerLanding",
    component: () =>
      import(
        /* webpackChunkName: "innerLanding" */ "@/layout/auto-claim/InnerLandingPage"
      ),
    meta: {
      layout: "/EmptyLayout",
    },
    beforeEnter: (to, from, next) => {
      next();
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/:hospitalCd",
    name: "outerLanding",
    component: () =>
      import(
        /* webpackChunkName: "outerLanding" */ "@/layout/auto-claim/OuterLandingPage"
      ),
    meta: {
      layout: "/EmptyLayout",
    },
    beforeEnter: (to, from, next) => {
      if (isNaN(to.params.hospitalCd)) {
        next(`/ui/insu/vuex/auto-claim/${to.params.hospitalCd}`);
      } else {
        next();
      }
    },
  },

  //알림톡
  {
    //
    path: "/ui/insu/vuex/auto-claim/web/idPhotoInfo",
    name: "idPhotoInfo",
    component: () => import("@/layout/auto-claim/web/IdPhotoInfo"),
    meta: {
      title: "신분증 촬영",
      path: "idPhotoInfo",
    },
  },
  {
    //
    path: "/ui/insu/vuex/auto-claim/web/IDPhoto",
    name: "webIdPhoto",
    component: () => import("@/layout/auto-claim/web/IDPhoto"),
    meta: {
      title: "신분증 촬영",
      path: "webIdPhoto",
    },
  },
  {
    //
    path: "/ui/insu/vuex/auto-claim/web/complete",
    name: "webComplete",
    component: () => import("@/layout/auto-claim/web/WebComplete"),
    meta: {
      title: null,
      path: "webComplete",
    },
    beforeEnter: (to, from, next) => {
      if (to.query.type == "idSubmit") {
        to.meta.title = "신분증 제출";
      } else {
        to.meta.title = "자동 청구 완료";
      }
      next();
    },
  },
  {
    //
    path: "/ui/insu/vuex/auto-claim/web/treat",
    name: "autoTreat",
    component: () => import("@/layout/auto-claim/web/AutoTreat"),
    meta: {
      title: "자동청구 진료내역",
      path: "autoTreat",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/web/jumin",
    name: "webJumin",
    component: () =>
      import(
        /* webpackChunkName: "jumin" */ "@/layout/auto-claim/web/JuminInput"
      ),
    meta: {
      title: "주민등록번호",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/web/signature",
    name: "webSigNatureInput",
    component: () =>
      import(
        /* webpackChunkName: "SignatureInput" */ "@/layout/auto-claim/web/SignatureInput"
      ),
    meta: {
      title: "서명",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/web/docComissionView",
    name: "webComission",
    component: () =>
      import(
        /* webpackChunkName: "comission" */ "@/layout/auto-claim/web/DocComissionView"
      ),
    meta: {
      title: "위임장",
    },
  },
  {
    path: "/ui/insu/vuex/auto-claim/web/docAgreeView",
    name: "webDocAgree",
    component: () =>
      import(
        /* webpackChunkName: "docAgree" */ "@/layout/auto-claim/web/DocAgreeView"
      ),
    meta: {
      title: "동의서",
    },
  },
];

function refresh() {
  var url = location.origin;
  var pathname = location.pathname;
  var hash = location.hash;
  let date = Math.floor(+new Date() / 1000);

  location = url + pathname + "?application_refresh=" + date;
}

import { store } from "@/store/index.js";
autoClaimRouterConfig.forEach((obj, index) => {
  if (!obj.beforeEnter) {
    obj.beforeEnter = (to, from, next) => {
      if (obj.path.includes("/security/")) {
        let authorization = AuthManager.utils.cookieBaker.get(
          "Authorization-autoClaim",
        );
        let compareVal = store.getters["autoClaim/getRespositData"].hash;
        let isAuthEnter =
          store.getters["autoClaim/getRespositData"].access_hash != ""; //인증했을 경우
        let isAccess = isAuthEnter
          ? Auth.decrypt(authorization, "@james600000") == compareVal
          : Auth.decrypt(authorization, "@james600000") != "";
        let isEmptyUserCi =
          store.getters["autoClaim/getPayloadData"].reg.userCi == "";

        new Promise((resolve) => {
          if (isAccess == false || isEmptyUserCi) {
            let { hospitalCd } = store.getters["autoClaim/getPayloadData"].reg;
            let redirectMessage = "유효하지 않은 인증입니다.";

            if (isEmptyUserCi) {
              redirectMessage = "잘못된 경로입니다.";
            }
            new Lemonhc.component.modal.alert(
              "알림",
              redirectMessage,
              function () {
                if (store.getters["autoClaim/getUiData"].prcMode == "inner") {
                  location.replace(`/ui/insu/vuex/auto-claim/`);
                } else {
                  location.replace(`/ui/insu/vuex/auto-claim/${hospitalCd}`);
                }
              },
            ).show();
          } else {
            next();
          }
        });
      } else {
        next();
      }
      // next();
    };
  }
  obj.meta = Object.assign(
    { layout: "/auto-claim/AutoClaimHomeLayout", pathNm: obj.name },
    obj.meta,
  );
});

export default autoClaimRouterConfig;
